import * as React from "react";
import styled from "styled-components";
import { Box } from "@material-ui/core";

export const CardHeader: React.FC<Props> = ({ title, subtitle, color}) => (
  <>
    <StyledBox display="flex" flexDirection="column">
        <StyledCardHeaderTitle color={color}>{title}</StyledCardHeaderTitle>
        {subtitle && <StyledCardHeaderSubtitle color={color}>{subtitle}</StyledCardHeaderSubtitle> }
    </StyledBox>
  </>
);

interface Props {
  title: string;
  subtitle: string;
  color: 'black'|'white';
}

const StyledBox = styled(Box)`
  padding: 20px;
`;

const StyledCardHeaderTitle = styled(({ color, ...rest }) => <h3 {...rest} >{rest.children}</h3>)<{color: 'black'|'white'}>`
  font-weight: bold;
  color: ${props => ((props.color) === 'black') ? '#000' : '#fff'};
`;

const StyledCardHeaderSubtitle = styled(({ color, ...rest }) => <p {...rest} >{rest.children}</p>)<{color: 'black'|'white'}>`
  margin-top: 5px;
  color: ${props => ((props.color) === 'black') ? '#000' : '#fff'};
`;
